import { List, TextField, EditButton, SimpleList, Datagrid, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { getPermissions } from "auth/security/securityUtils";
import { checkPermission } from "server/security/utils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, STATE_EXAMS } from "utils/constants";
import { EducationsExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const ListStateExams = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={EducationsExporter(STATE_EXAMS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateStateExams)} />}
      title="Списък с държавни изпити"
      sx={settings.style.expandStyle}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
          )}
          tertiaryText={record => (
            <>{checkPermission(userPermissions, permissions.canUpdateStateExams) && <EditButton label="" />}</>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="nameBg"
            label="Име на български език"
            sortable={false}
          />
          <TextField
            source="nameEn"
            label="Име на английски език"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateStateExams) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListStateExams;
